import {CommonModule} from '@angular/common'
import {ChangeDetectorRef, Component, OnInit} from '@angular/core'
import {HttpClient} from '@angular/common/http';
import {LoadingService} from 'src/app/services/loading.service';
import {catchError, of} from 'rxjs';
import {ConfigService} from 'src/app/services/config.service';
import {LegalService} from "../../services/legal.service";

@Component({
  selector: 'connected-privacy-policy',
  standalone: true,
  templateUrl: './connected-privacy-policy.component.html',
  styleUrl: './connected-privacy-policy.component.scss',
  imports: [CommonModule]
})
export class ConnectedPrivacyPolicyComponent implements OnInit {
  text: any;

  constructor(private http: HttpClient,
              private cdr: ChangeDetectorRef,
              private loadingService: LoadingService,
              private configService: ConfigService,
              private legalService: LegalService) {
  }

  ngOnInit() {
    this.loadingService.showLoading();
    this.http.get(this.legalService.getLegalDocument('privacy-policy')).pipe(
      catchError((error) => {
        console.error('Error occurred:', error);
        this.loadingService.hideLoading();
        return of({});
      })
    ).subscribe((data: any) => {
      this.text = this.getText(data['copy']);
      this.loadingService.hideLoading();
      this.cdr.markForCheck();
    });
  }

  private getText(data: any) {
    return decodeURIComponent(escape(atob(data)));
  }
}
